import { Dot, DotType, EntityType, Shape } from '@/features/map/types/shape'
import { useState } from 'react'
import { polygonsIntersect } from '../utils/mapCollision'

export function useMapEntityEditor({
  initialShapes = [],
  initialDots = [],
}: {
  initialShapes?: Shape[]
  initialDots?: Dot[]
}) {
  const [shapes, setShapes] = useState<Shape[]>(initialShapes)
  const [editShape, setEditShape] = useState<Shape | null>(null)
  const [tempShapeId, setTempShapeId] = useState<string | null>(null)

  const [dots, setDots] = useState<Dot[]>(initialDots)
  const [editDot, setEditDot] = useState<Dot | null>(null)
  const [tempDotId, setTempDotId] = useState<string | null>(null)

  const hasShapeCollision = (points: [number, number][], excludeId?: string) => {
    return shapes.some(shape => {
      if (shape.id === excludeId) return false
      if (!shape.points) return false

      return polygonsIntersect(points, shape.points)
    })
  }

  const handleSaveShape = (result: [number, number][], entityType: EntityType, label = 'New Area') => {
    const newShape: Shape = {
      id: crypto.randomUUID(),
      label,
      entityType,
      color: '#22c55e',
      points: result,
    }

    setShapes(prev => [...prev, newShape])
    setTempShapeId(newShape.id)
  }

  const handleEditShape = (id: string) => {
    const found = shapes.find(s => s.id === id)
    if (found) {
      setEditShape(found)
    }

    setShapes(prev => prev.filter(s => s.id !== id))
  }

  const handleCancelShape = () => {
    if (editShape) {
      setShapes(prev => [...prev, editShape])
      setEditShape(null)
    }

    if (tempShapeId) {
      setShapes(prev => prev.filter(s => s.id !== tempShapeId))
      setTempShapeId(null)
    }
  }

  const handleSaveDot = (result: [number, number], dotType: DotType, label = 'New') => {
    const newDot: Dot = {
      id: crypto.randomUUID(),
      label,
      dotType,
      color: '#22c55e',
      point: result,
    }
    setDots(prev => [...prev, newDot])

    setTempDotId(newDot.id)
  }

  const handleEditDot = (id: string) => {
    const found = dots.find(p => p.id === id)

    if (!found) return

    setEditDot(found)
    setDots(prev => prev.filter(p => p.id !== id))
  }

  const handleCancelDot = () => {
    if (editDot) {
      setDots(prev => [...prev, editDot])
      setEditDot(null)
    }

    if (tempDotId) {
      setDots(prev => prev.filter(p => p.id !== tempDotId))
      setTempDotId(null)
    }
  }

  return {
    shapes,
    setShapes,
    hasShapeCollision,
    handleSaveShape,
    handleEditShape,
    handleCancelShape,

    dots,
    setDots,
    handleSaveDot,
    handleEditDot,
    handleCancelDot,
  }
}
